angular
    .module('app')
    .constant('secureTrading',
    {
        siteReference: 'aifsaupairp67871'
    });